"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yearRange = exports.range = exports.dayRange = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _types = require("../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var OptionDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionDefinition;
});

var formatDayValue = function formatDayValue(n) {
  return n < 10 ? "0".concat(n) : n;
}; // $FlowFixMe WEB-352


var currentYear = Math.floor((0, _moment["default"])().format('YYYY'));

var range = function range(start, end) {
  var rangeArray = [];

  for (var i = start; i <= end; i += 1) {
    rangeArray.push(i);
  }

  return rangeArray;
};

exports.range = range;

var dayRange = function dayRange(startDay, endDay) {
  var items = range(startDay, endDay).map(function (item) {
    return {
      key: formatDayValue(item).toString(),
      label: item.toString()
    };
  });
  return items;
};

exports.dayRange = dayRange;

var yearRange = function yearRange(maxYearFromToday, minYearFromToday) {
  var startYear = minYearFromToday ? currentYear + minYearFromToday : 1900;
  var endYear = maxYearFromToday ? currentYear + maxYearFromToday : currentYear;
  var items = range(startYear, endYear).map(function (item) {
    return {
      key: item.toString(),
      label: item.toString()
    };
  });
  return items;
};

exports.yearRange = yearRange;